// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","535":"login","685":"register","770":"routes","995":"collects-create"}[chunkId] || chunkId) + "." + {"42":"847b8f62","177":"1a8771af","513":"572692ef","535":"0d1508a7","685":"2ef3376b","708":"eaf5d4e8","748":"d66919b8","770":"e04f79ab","900":"2c22beff","995":"351b7bc1"}[chunkId] + ".js";
};